



































import { Popup, Button, DialogView } from '@hb/coffee';
import {
  defineComponent,
  computed,
} from '@vue/composition-api';
import store from '@/store';

export default defineComponent({
  name: 'CouponDiscountPopup',
  components: {
    Popup,
    Button,
    DialogView,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
  setup(props, { emit }) {
    /** 是否展示popup */
    const showPopup = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value),
    });

    /** 券优惠金额 */
    const couponDiscountAmount = computed(
      () => store.state.applyProduct?.planListData?.couponDiscountAmount || 0,
    );
    /** 点击确定 */
    const handleConfirm = () => {
      emit('confirm');
    };

    /** 点击放弃 */
    const handleCancel = () => {
      emit('cancel');
    };

    return {
      showPopup,
      handleConfirm,
      handleCancel,
      couponDiscountAmount,
    };
  },
});
